export default __webpack_public_path__ + "static/video-1-e070fa74960ebc11fbff7f3eb58e900f.png";